import { number, string } from 'prop-types';
import Box from './layouts/Box';

const ProgressBar = ({
  value = 1,
  total = 1,
  color = 'primary',
  height = '4px',
  ...boxProps
}) => (
  <Box {...boxProps} height={height}>
    <Box bg={color} width={`${(value / total) * 100}%`} height={height} />
  </Box>
);

ProgressBar.propTypes = {
  value: number,
  total: number,
  bg: string,
  color: string,
  height: string
};

ProgressBar.defaultProps = {
  value: 1,
  total: 1,
  color: 'primary',
  bg: 'border',
  height: '4px'
};

export default ProgressBar;
